import * as React from 'react';

function TimerIcon(props) {
    const { color = '#FFF' } = props;
    return (
        <svg width="17" height="15" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.749 0C5.23493 0 0.749023 4.48601 0.749023 10C0.749023 15.514 5.23493 20 10.749 20C16.2631 20 20.749 15.514 20.749 10C20.749 4.48601 16.2631 0 10.749 0ZM10.749 18.9478C5.81512 18.9478 1.80127 14.9338 1.80127 10C1.80127 5.0662 5.81512 1.05224 10.749 1.05224C15.6829 1.05224 19.6968 5.0662 19.6968 10C19.6968 14.9338 15.6829 18.9478 10.749 18.9478Z" fill="#707070" />
            <path d="M11.2756 9.78107V4.03393C11.2756 3.74332 11.04 3.50781 10.7495 3.50781C10.459 3.50781 10.2234 3.74332 10.2234 4.03393V9.999C10.2234 10.1385 10.2789 10.2723 10.3776 10.371L13.5355 13.529C13.6381 13.6317 13.7728 13.6831 13.9075 13.6831C14.0421 13.6831 14.1768 13.6317 14.2794 13.529C14.485 13.3235 14.485 12.9904 14.2794 12.7849L11.2756 9.78107Z" fill="#707070" />
        </svg>

    );
}

export default TimerIcon;
